module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {}, [_c('router-link', {
    attrs: {
      "to": {
        name: 'single',
        params: {
          slug: _vm.link
        }
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.goToDataView($event)
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.title))])])], 1), _vm._v(" "), _c('td', {}, [_c('span', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm.term))])]), _vm._v(" "), _c('td', {}, [(_vm.area) ? _c('p', [_vm._v(_vm._s(_vm.area))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48d6f2a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fileRow.vue
// module id = 55
// module chunks = 1